import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';
import SectionHeader from 'views/SectionHeader.js';

const Testimonials = () => {

    const testimonials = [
        {
            name: 'RonnieDean1',
            role: 'app_store_customer',
            text: 'Have had the system for almost 6 years. I’m thankful for the peace of mind and the app letting me check in on my family when I’m working or out of town.'
        },{
            name: 'Lorelei P',
            role: 'google_customer',
            text: 'Sept 18, 2020 I got an alert that there was water leak detected at my washing machine. Once I got home to check it out I found my entire detached garage flooded from a heavy rainfall. Had I not had that sensor the damage would have been so much worse!! Thank you for these products and for your awesome people out there protecting homes!'
        },{
            name: 'Alexzondria S',
            role: 'play_store_customer',
            text: 'If an alarm goes off the reps and myself are alerted through the app. Was able to address a water leak quickly when my sensor alerted me of a water leak. Worth every penny considering this system could save me thousands of dollars on issues that could easily be missed and turn into huge repair bills.'
        },{
            name: 'Jdog47',
            role: 'app_store_customer',
            text: 'I was alerted to a water leak on my phone when I was 4 hours away and was able to have a friend of mine come in my home and plug in my sump pump that came out most likely from my cats wrestling around it. Saved my basement!!!!! Thanks!! The app is a complete game changer!!!!!'
        },{
            name: 'Joshua P',
            role: 'google_customer',
            text: 'Amazing products! This company protects the world one family at a time!'
        },{
            name: 'Karen B',
            role: 'customer_story',
            text: 'The decision to buy this system was one of the best decisions we have made. It has saved our house from water damage as well as our lives.'
        },{
            name: 'Tonia J',
            role: 'play_store_customer',
            text: 'Installed the same day and works wonderfully. Team is great. Temperature sensor have notified us the temp by the water inlet for our dishwasher is too cold and the laundry room was too hot. Water sensors have notified us twice there was water in our basement a few once in the bathroom when the Grandson was enjoying his bath time just a little too much.'
        },{
            name: 'Sloan F',
            role: 'customer_story',
            text: `[Installer name redacted] just install our water sensor today and while using our dishwasher we got a notification of a water leaking under our kitchen sink. So glad to have had one there because I wouldn't have know about the leakage. 10/10 would recommend these to my friends and family.`
        },{
            name: 'Robert K',
            role: 'play_store_customer',
            text: `The water sensors have saved us from five different floods. I would definitely recommend these sensors to anyone that lives in a house.`
        },{
            name: 'Geoff Y',
            role: 'customer_story',
            text: `Honest and reliable. Looking for home safety this product is top notch.`
        },{
            name: 'Michael W',
            role: 'play_store_customer',
            text: `Amazing app. Easy to use. Punch your codes in from your comlink they are written on the bottom and you're good to go! Super awsome I can put family and neighbours as emergency contacts. I'd recommend his network to everyone I care about.`
        },{
            name: 'Kortney B',
            role: 'customer_story',
            text: `I am very happy we have decided to purchase these safety feature for our home. Longer battery and more reliable! We couldn’t be happier or safer in our house.`
        },{
            name: 'Macayla & Mathew D.',
            role: 'customer_story',
            text: `We chose to invest in the system because the success rate of the other brand was not what we were expecting. Which is not good enough for our family. `
        }
    ];

    const getTestimonialsAssets = role => {
        switch(role) {
            case 'app_store_customer':
            return {
                icon: '/images/app-store-icon.png',
                name: 'App Store Customer'
            }

            case 'customer_story':
            return {
                icon: '/images/avatar_placeholder.png',
                name: 'Customer Testimonial'
            }

            case 'google_customer':
            return {
                icon: '/images/google-review-icon.png',
                name: 'Google Customer'
            }

            case 'play_store_customer':
            return {
                icon: '/images/play-store-icon.png',
                name: 'Play Store Customer'
            }
        }
    }

    return (
        <section style={{
            width: '100%',
            backgroundColor: Appearance.colors.offWhite,
            overflow: 'hidden',
        }}>
            <div style={{
                margin: '0 auto',
                padding: Appearance.layout.sectionPadding(),
                textAlign: 'center',
            }}>
                <SectionHeader
                    eyebrow={'Customer Stories'}
                    title={'What Our Clients Say'}
                    subtitle={'Real stories from real customers who trust Aqua Link to protect their homes and families.'} />

                {/* Auto-scrolling testimonials marquee */}
                <div className={'al-marquee-viewport'} style={{
                    marginTop: 50,
                    width: '100%',
                    padding: '16px 0',
                    overflow: 'hidden',
                    WebkitMaskImage: 'linear-gradient(to right, transparent, #000 7%, #000 93%, transparent)',
                    maskImage: 'linear-gradient(to right, transparent, #000 7%, #000 93%, transparent)',
                }}>
                    <div className={'al-marquee-track'} style={{
                        display: 'flex',
                        width: 'max-content',
                    }}>
                        {[...testimonials, ...testimonials].map((testimonial, index) => {

                            let { icon, name } = getTestimonialsAssets(testimonial.role);
                            return (
                                <div key={index} style={{
                                    ...Appearance.styles.card(),
                                    boxShadow: Appearance.boxShadow.card,
                                    padding: 32,
                                    marginRight: 30,
                                    textAlign: 'left',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 20,
                                    width: Utils.isMobile() ? 300 : 380,
                                    flexShrink: 0,
                                    whiteSpace: 'normal',
                                }}>
                                    {/* Avatar and Name */}
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 14,
                                    }}>
                                        <div style={{
                                            width: 48,
                                            height: 48,
                                            borderRadius: 24,
                                            backgroundColor: icon ? null : Appearance.colors.primary(),
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            overflow: 'hidden',
                                            flexShrink: 0,
                                        }}>
                                            {icon ? (
                                                <img
                                                    src={icon}
                                                    alt={testimonial.name}
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                            ) : (
                                                <span style={{
                                                    fontFamily: Appearance.fonts.body,
                                                    fontWeight: 700,
                                                    fontSize: 16,
                                                    color: Appearance.colors.white,
                                                }}>
                                                    {testimonial.initials}
                                                </span>
                                            )}
                                        </div>
                                        <div>
                                            <span style={{
                                                ...Appearance.textStyles.body({ fontWeight: 700, color: Appearance.colors.text() }),
                                                display: 'block',
                                            }}>
                                                {testimonial.name}
                                            </span>
                                            <span style={Appearance.textStyles.caption()}>
                                                {name}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Quote */}
                                    <p style={{
                                        ...Appearance.textStyles.body({ fontSize: 14, lineHeight: 1.7 }),
                                        flexGrow: 1,
                                    }}>
                                        {`"${testimonial.text}"`}
                                    </p>

                                    {/* Stars */}
                                    <div style={{
                                        display: 'flex',
                                        gap: 4,
                                    }}>
                                        {[1,2,3,4,5].map(star => (
                                            <i key={star} className={'fas fa-star'} style={{
                                                fontSize: 14,
                                                color: Appearance.colors.primary(),
                                            }} />
                                        ))}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
